import {Injectable} from '@angular/core';
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {TeTemplateGenerateResponseDto} from "../../model/dto/entity/te-template-generate-response.dto";
import {TeTemplateGenerateRequestDto} from "../../model/dto/entity/te-template-generate-request.dto";
import {ObjectIdentifierWithId} from "../../../../core/shared/basic/object-identifier.with.id";

@Injectable({
  providedIn: 'root'
})
export class TeArtefactService extends MvsCrudService{

  constructor(protected http: HttpClient) {
    super(http, MvsCrudService.baseUrl + '/te/teArtefacts');
  }

  generateViaTestCase(
      artefactId: number,
      testCaseId: number,
      generatePdf: boolean,
      objectVariables: {[key: string]: ObjectIdentifierWithId},
      simpleVariables: {[key: string]: any},
      contextScenarios?: {[alias: string]: string}) : Observable<TeTemplateGenerateResponseDto> {

    const requestDto = new TeTemplateGenerateRequestDto(
        true,
        true,
        testCaseId,
        generatePdf,
        objectVariables,
        simpleVariables,
        contextScenarios);

    return this.http.post<TeTemplateGenerateResponseDto>(this.apiUrl + `/generate/${artefactId}`, requestDto);
  }
}
